import { i18n } from '@lingui/core';

export interface PourPresetGroupsPageParams extends Record<string, string | undefined> {
    projectId: string;
  }

export const ROUTE_PARAM_IDENTIFIER = ':projectId';

  export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/pour-preset-groups`;
  export const TITLE = i18n._('Pour Preset Groups');
